import { TournamentHeader } from "./TournamentHeader";
import { Tournament } from "@portal-frontend-ssr/blast-data-api";
import { GameId } from "@portal-frontend-ssr/blast-api";
import { AdaptiveLink } from "@portal-frontend-ssr/ui";
import { generateTeamLogoSrc } from "~/shared/helpers/url/generateTeamLogoSrc";
import { generateTournamentLink } from "~/shared/helpers/tournaments/generateTournamentLink";

interface UpcomingTournamentProps {
  gameId: GameId;
  tournament: Tournament;
}

export const UpcomingTournament = ({ gameId, tournament }: UpcomingTournamentProps) => {
  const participatingTeams = tournament.participants ? tournament.participants : [];
  const numberOfTeams = tournament.numberOfTeams ?? 0;
  const placeholderTeams = numberOfTeams > participatingTeams.length ? numberOfTeams - participatingTeams.length : 0;

  const tournamentLink = generateTournamentLink({ gameId, tournamentId: tournament.id });

  return (
    <AdaptiveLink
      to={tournamentLink}
      className="flex flex-col gap-4 rounded-small bg-background-95 p-3 transition-all hover:bg-background-90"
    >
      <TournamentHeader tournament={tournament} />
      <div className="grid w-fit max-w-full grid-cols-8 gap-x-5 gap-y-3">
        {participatingTeams.map((team) => {
          return (
            <img
              className="size-5 object-contain"
              key={team.id}
              src={generateTeamLogoSrc({ id: team.id, height: 20 })}
              alt={team.name}
              loading="lazy"
            />
          );
        })}
        {Array.from({ length: placeholderTeams }).map((_, index) => {
          return (
            <div
              className="flex size-5 items-center justify-center rounded-full bg-background-85 text-neutral font-style-label-l4"
              key={index}
            >
              ?
            </div>
          );
        })}
      </div>
    </AdaptiveLink>
  );
};
